import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=ca7b3cf4&"
import script from "./InputFile.vue?vue&type=script&lang=js&"
export * from "./InputFile.vue?vue&type=script&lang=js&"
import style0 from "./InputFile.vue?vue&type=style&index=0&id=ca7b3cf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports